import { render, staticRenderFns } from "./PackingForm.vue?vue&type=template&id=1887b220&scoped=true&"
import script from "./PackingForm.vue?vue&type=script&lang=js&"
export * from "./PackingForm.vue?vue&type=script&lang=js&"
import style0 from "./PackingForm.vue?vue&type=style&index=0&id=1887b220&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1887b220",
  null
  
)

export default component.exports